import React, { useContext } from 'react';
import { PageShellLayout, PageShell } from 'src/styles/pageLayoutStyles';
import styled from 'styled-components';
import { SustainabilityLandingPageConstants } from 'src/constants/ProjectConstants';
import { DDMContextInjector } from 'src/integration/ddm/hydrator/DDMContextInjector';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { DDM_SCHEMA_ID_FOR_PROGRAMS } from 'src/constants/GlobalConstants';
import { CreateCaseFormWithCaptcha } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha';
import { REPORTING_TYPE } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha/CreateCaseFormWithCaptcha';
import { Breadcrumb } from 'src/components/Breadcrumb';
import { ANONYMOUS_CREATE_CASE_PAGE_ROUTE } from 'src/constants/UrlConstants';

const CreateCaseFormContainer = styled.div`
  padding: 0rem 0rem 0rem 0rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.Zircon};
`;

const AnonymousCreateCasePage = () => {
  const { socialResponsibilityLandingPageBundle, commonBundle } =
    useContext(TranslationContext);

  return (
    <>
      <Breadcrumb page={ANONYMOUS_CREATE_CASE_PAGE_ROUTE}></Breadcrumb>
      <PageShellLayout>
        <PageShell>
          <CreateCaseFormContainer
            id="anonymous-create-case-component"
            data-testid="anonymous-create-case-component"
          >
            <DDMContextInjector
              schemaKey={DDM_SCHEMA_ID_FOR_PROGRAMS.SUSTAINABILITY}
            >
              <CreateCaseFormWithCaptcha
                reportingType={REPORTING_TYPE.ANONYMOUS}
                allowAttachments={true}
                showReferralInfo={false}
                successModalBody={socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.ANONYMOUS_CREATE_CASE_MODAL_SUCCESS_MESSAGE,
                )}
                messages={{
                  CREATE_CASE_FAILURE_MESSAGE:
                    socialResponsibilityLandingPageBundle.getMessage(
                      SustainabilityLandingPageConstants.ANONYMOUS_CREATE_CASE_FAILURE_MESSAGE,
                    ),
                  CREATE_CASE_SUCCESSFUL_MODAL_HEADER:
                    socialResponsibilityLandingPageBundle.getMessage(
                      SustainabilityLandingPageConstants.ANONYMOUS_CREATE_CASE_MODAL_TITLE,
                    ),
                  CREATE_CASE_SUCCESSFUL_MODAL_BUTTON_CLOSE_LABEL:
                    commonBundle.getMessage(
                      SustainabilityLandingPageConstants.REPORTING_CARD_LOGIN_ACTION_BUTTON_LABEL_CLOSE,
                    ),
                  REPORT_A_CASE_HEADER:
                    socialResponsibilityLandingPageBundle.getMessage(
                      SustainabilityLandingPageConstants.REPORT_A_CASE_HEADER,
                    ),
                  REPORT_A_CASE_DESCRIPTION:
                    socialResponsibilityLandingPageBundle.getMessage(
                      SustainabilityLandingPageConstants.REPORT_A_CASE_DESCRIPTION,
                    ),
                  CAPTCHA_TITLE:
                    socialResponsibilityLandingPageBundle.getMessage(
                      SustainabilityLandingPageConstants.CAPTCHA_MODAL_TITLE,
                    ),
                }}
              />
            </DDMContextInjector>
          </CreateCaseFormContainer>
        </PageShell>
      </PageShellLayout>
    </>
  );
};

export { AnonymousCreateCasePage };
